import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";

function createData(adminLevel, status, comment) {
	return { adminLevel, status, comment };
}

export default function AdminApprovalStatus({ adminLevels }) {
	// console.log(adminLevels);
	const rows = [
		createData(adminLevels[0]?.admin, adminLevels[0]?.status, adminLevels[0]?.comment),
		createData(adminLevels[1]?.admin, adminLevels[1]?.status, adminLevels[1]?.comment),
		createData(adminLevels[2]?.admin, adminLevels[2]?.status, adminLevels[2]?.comment),
		createData(adminLevels[3]?.admin, adminLevels[3]?.status, adminLevels[3]?.comment),
		createData(adminLevels[4]?.admin, adminLevels[4]?.status, adminLevels[4]?.comment),
		// createData(adminLevels[5]?.admin, adminLevels[5]?.status, adminLevels[5]?.comment),
	];

	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 600 }} aria-label='simple table'>
				<TableHead>
					<TableRow>
						<TableCell>Admin Levels / Dept</TableCell>
						<TableCell align='center'>Approval Status</TableCell>
						<TableCell align='right'>Admin Comment</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((row) => (
						<TableRow key={row.adminLevel} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
							<TableCell component='th' scope='row'>
								{row.adminLevel}
							</TableCell>
							<TableCell
								align='center'
								sx={{
									color: row?.status?.toLowerCase().includes("approv")
										? "green"
										: row?.status?.toLowerCase().includes("reject")
										? "red"
										: "black",
								}}>
								{row.status?.toLowerCase().includes("approve")
									? "Approved"
									: row?.status?.toLowerCase().includes("reject")
									? "Rejected"
									: row?.status === "Recommend for Approval"
									? "Recommended for Approval"
									: row.status || "--"}
							</TableCell>
							<TableCell align='right'>{row.comment || "--"}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

AdminApprovalStatus.propTypes = {
	adminLevels: PropTypes.array,
};
